import { ReactNode } from 'react';

import { EyeInvisibleOutlined } from '@ant-design/icons';
import { Avatar, Tooltip } from 'antd';

import EventTypeIcon from '@src/components/EventTypeIcon';
import type { TEventTypeSummary } from '@src/models/interfaces/eventTypeSummary.interface';
import IntlMessages from '@src/util/IntlMessages';

import styles from '../styles.module.less';

export interface EventNameProps {
  eventColor?: TEventTypeSummary['color'] | string | null;
  eventIcon?: string | null;
  eventName?: ReactNode;
  formName?: ReactNode;
}

const EventName = ({
  eventColor = null,
  eventIcon = null,
  eventName = '',
  formName = '',
}: EventNameProps) => {
  const color = eventColor && typeof eventColor === 'object' ? eventColor : null;

  return (
    <div className={styles.triggerNameContainer}>
      {color && eventIcon ? (
        <div className={styles.triggerNameIcon}>
          <EventTypeIcon color={color} icon={eventIcon} />
        </div>
      ) : (
        <div className={styles.triggerNameIcon}>
          <Avatar size={32} icon={<EyeInvisibleOutlined />} />
        </div>
      )}
      <div className={styles.triggerNameTitle}>
        <span className="gx-mr-2 gx-ml-2">{eventName}</span>
        {formName && (
          <Tooltip placement="bottom" title={<IntlMessages id="general.form" />}>
            <div className="gx-d-flex gx-align-items-center gx-guarnic-gap-1">
              <span className="material-symbols-outlined gx-fs-md gx-guarnic-body-light">
                assignment
              </span>
              <span className="gx-guarnic-body-light gx-flex-nowrap">{formName}</span>
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default EventName;
